(function (global) {
  'use strict';

  function text(node) {
    return node ? node.textContent.trim() : '';
  }

  function absoluteUrl(value, base) {
    if (!value) return '';
    try { return new URL(value, base).href; } catch (error) { return ''; }
  }

  function parseInstant(value) {
    var parsed = Date.parse(value || '');
    return Number.isFinite(parsed) ? parsed : null;
  }

  function write(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function writeCountdown(root, distance) {
    var total = Math.max(0, Math.floor(distance / 1000));
    write(root, '[data-days]', String(Math.floor(total / 86400)));
    write(root, '[data-hours]', String(Math.floor(total % 86400 / 3600)).padStart(2, '0'));
    write(root, '[data-minutes]', String(Math.floor(total % 3600 / 60)).padStart(2, '0'));
    write(root, '[data-seconds]', String(total % 60).padStart(2, '0'));
  }

  function validSourceCard(card) {
    var start = parseInstant(card.dataset.startAt);
    var end = parseInstant(card.dataset.endAt);
    return Boolean(card.dataset.eventId && start !== null && end !== null && end > start) &&
      card.dataset.plannerStatus === 'approved' &&
      card.dataset.visibility === 'public_when_active' &&
      card.dataset.offerStatus !== 'inactive';
  }

  function cardIsActive(card, now) {
    var start = parseInstant(card.dataset.startAt);
    var end = parseInstant(card.dataset.endAt);
    return start !== null && end !== null && now >= start && now < end;
  }

  function makeElement(name, className, value) {
    var node = global.document.createElement(name);
    if (className) node.className = className;
    if (value) node.textContent = value;
    return node;
  }

  function buildCard(source, sourceUrl, root) {
    var card = makeElement('article', 'dm-home-events__card');
    card.dataset.dmHomeEventCard = '';
    card.dataset.eventId = source.dataset.eventId;
    card.dataset.startAt = source.dataset.startAt;
    card.dataset.endAt = source.dataset.endAt;
    card.hidden = true;
    card.setAttribute('aria-hidden', 'true');

    var media = makeElement('div', 'dm-home-events__media');
    var sourceImage = source.querySelector('img');
    if (sourceImage) {
      var image = global.document.createElement('img');
      image.src = absoluteUrl(sourceImage.getAttribute('src'), sourceUrl);
      image.alt = sourceImage.getAttribute('alt') || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      var sourceSet = sourceImage.getAttribute('srcset');
      if (sourceSet) image.setAttribute('srcset', sourceSet);
      var sizes = sourceImage.getAttribute('sizes');
      if (sizes) image.setAttribute('sizes', sizes);
      media.appendChild(image);
    }

    var content = makeElement('div', 'dm-home-events__content');
    var subtitle = text(source.querySelector('.promo-event__eyebrow'));
    var title = text(source.querySelector('h2'));
    var offer = text(source.querySelector('.promo-event__offer'));
    var terms = text(source.querySelector('.promo-event__terms'));
    if (subtitle) content.appendChild(makeElement('p', 'dm-home-events__subtitle fs-accent', subtitle));
    if (title) content.appendChild(makeElement('h2', 'dm-home-events__title ff-heading fs-heading-2-base', title));

    var body = makeElement('div', 'dm-home-events__body rte ff-body fs-body-100');
    if (offer) body.appendChild(makeElement('p', 'dm-home-events__offer', offer));
    if (terms) body.appendChild(makeElement('p', 'dm-home-events__terms', terms));
    content.appendChild(body);

    var timer = makeElement('p', 'dm-home-events__timer ff-body fs-body-75');
    timer.appendChild(makeElement('span', '', root.dataset.countdownLabel || 'Offer ends in'));
    var time = makeElement('time', 'dm-home-events__time');
    time.dateTime = source.dataset.endAt;
    [['days', 'dayUnit', '0'], ['hours', 'hourUnit', '00'], ['minutes', 'minuteUnit', '00'], ['seconds', 'secondUnit', '00']].forEach(function (part) {
      var span = makeElement('span');
      var strong = makeElement('strong', '', part[2]);
      strong.setAttribute('data-' + part[0], '');
      span.appendChild(strong);
      span.appendChild(global.document.createTextNode(root.dataset[part[1]] || part[0].charAt(0)));
      time.appendChild(span);
    });
    timer.appendChild(time);
    content.appendChild(timer);

    var sourceLink = source.querySelector('a');
    if (sourceLink && sourceLink.getAttribute('href')) {
      var actions = makeElement('div', 'dm-home-events__actions');
      var link = makeElement('a', 'btn btn--primary', text(sourceLink));
      link.href = absoluteUrl(sourceLink.getAttribute('href'), sourceUrl);
      actions.appendChild(link);
      content.appendChild(actions);
    }

    card.appendChild(media);
    card.appendChild(content);
    return card;
  }

  function initialize(root) {
    if (!root || root.dataset.dmHomeEventsInitialized === 'true') return;
    root.dataset.dmHomeEventsInitialized = 'true';
    var viewport = root.querySelector('[data-dm-home-events-viewport]');
    var navigation = root.querySelector('[data-dm-home-events-navigation]');
    var dots = root.querySelector('[data-dm-home-events-dots]');
    var previous = root.querySelector('[data-dm-home-events-previous]');
    var next = root.querySelector('[data-dm-home-events-next]');
    var allCards = [];
    var activeCards = [];
    var selectedIndex = 0;
    var interval = null;
    var lastAdvance = Date.now();
    var paused = false;
    var reduceMotion = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayMilliseconds = Math.max(4000, Number(root.dataset.autoplaySeconds || 6) * 1000);

    function renderSelected() {
      activeCards.forEach(function (card, index) {
        var selected = index === selectedIndex;
        card.hidden = !selected;
        card.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      Array.prototype.forEach.call(dots ? dots.querySelectorAll('button') : [], function (dot, index) {
        dot.setAttribute('aria-current', index === selectedIndex ? 'true' : 'false');
      });
    }

    function select(index) {
      if (activeCards.length < 2) return;
      selectedIndex = (index + activeCards.length) % activeCards.length;
      lastAdvance = Date.now();
      renderSelected();
    }

    function buildNavigation() {
      if (!navigation || !dots) return;
      dots.textContent = '';
      activeCards.forEach(function (card, index) {
        var dot = makeElement('button', 'dm-home-events__dot');
        dot.type = 'button';
        dot.setAttribute('aria-label', (root.dataset.eventLabel || 'Event') + ' ' + String(index + 1));
        dot.addEventListener('click', function () { select(index); });
        dots.appendChild(dot);
      });
      navigation.hidden = activeCards.length < 2;
    }

    function reconcile() {
      var now = Date.now();
      var nextActive = allCards.filter(function (card) { return cardIsActive(card, now); });
      var changed = nextActive.length !== activeCards.length || nextActive.some(function (card, index) { return card !== activeCards[index]; });
      activeCards = nextActive;
      if (selectedIndex >= activeCards.length) selectedIndex = 0;
      allCards.forEach(function (card) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
      });
      root.classList.toggle('is-ready', activeCards.length > 0);
      root.dataset.activeEventCount = String(activeCards.length);
      if (changed) {
        buildNavigation();
        lastAdvance = now;
      }
      if (!activeCards.length) return;
      activeCards.forEach(function (card) {
        writeCountdown(card, parseInstant(card.dataset.endAt) - now);
      });
      if (!paused && !reduceMotion && activeCards.length > 1 && now - lastAdvance >= autoplayMilliseconds) {
        selectedIndex = (selectedIndex + 1) % activeCards.length;
        lastAdvance = now;
      }
      renderSelected();
    }

    if (previous) previous.addEventListener('click', function () { select(selectedIndex - 1); });
    if (next) next.addEventListener('click', function () { select(selectedIndex + 1); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; lastAdvance = Date.now(); });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) { paused = false; lastAdvance = Date.now(); }
    });

    var sourceUrl = absoluteUrl(root.dataset.sourceUrl || '/pages/events', global.location.origin);
    fetch(sourceUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Events source unavailable');
        return response.text();
      })
      .then(function (markup) {
        var sourceDocument = new DOMParser().parseFromString(markup, 'text/html');
        var sources = Array.prototype.slice.call(sourceDocument.querySelectorAll('[data-promo-event]')).filter(validSourceCard);
        viewport.textContent = '';
        allCards = sources.map(function (source) { return buildCard(source, sourceUrl, root); });
        allCards.forEach(function (card) { viewport.appendChild(card); });
        root.dataset.sourceStatus = 'loaded';
        reconcile();
        interval = global.setInterval(reconcile, 1000);
      })
      .catch(function () {
        root.dataset.sourceStatus = 'error';
        root.classList.remove('is-ready');
      });

    root.dmHomeEventsDestroy = function () {
      if (interval) global.clearInterval(interval);
      delete root.dmHomeEventsDestroy;
      delete root.dataset.dmHomeEventsInitialized;
    };
  }

  function initializeAll(container) {
    var scope = container && container.querySelectorAll ? container : global.document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dm-home-events]'), initialize);
    if (scope.matches && scope.matches('[data-dm-home-events]')) initialize(scope);
  }

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { initializeAll(global.document); });
    } else {
      initializeAll(global.document);
    }
    global.document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
    global.document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(event.target.querySelectorAll('[data-dm-home-events]'), function (root) {
        if (root.dmHomeEventsDestroy) root.dmHomeEventsDestroy();
      });
    });
  }

  global.DellamodaHomeEvents = {
    cardIsActive: cardIsActive,
    validSourceCard: validSourceCard,
    initializeAll: initializeAll
  };
}(typeof window !== 'undefined' ? window : globalThis));
